import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { CreateComponentProps } from '../../Routers/CrudRouter';
import { useGoBackFromCreate } from '../../../utils/crudHooks';
import { InsertCategoryRequest } from '../../../swagger/putujmoAdminService';
import { tryCatchJsonByAction } from '../../../utils/fetchUtils';
import { Dialog } from '../../../components/Dialog/Dialog';
import { LoadingSpinner } from '../../../components/LoadingSpinner/LoadingSpinner';
import { CrudEnum } from '../../../settings/routes';
import { CategoryForm } from '../CategoryForm';
import { createCategoryAction } from '../../../features/categories/action';

export const CreateCategory = ({ publishDataChanged, additionalData }: CreateComponentProps) => {
	const [loading, setLoading] = useState(false);
	const goBackFromCreate = useGoBackFromCreate();

	const handleSave = useCallback(
		async (newValues: InsertCategoryRequest) => {
			setLoading(true);
			const bindedAction = createCategoryAction.bind(null, newValues);
			const response = await tryCatchJsonByAction(bindedAction);
			setLoading(false);

			if (response.success) {
				toast.success('Novi element je uspešno kreiran.');
				publishDataChanged();
				goBackFromCreate();
			} 
		},
		[goBackFromCreate, publishDataChanged]
	);

	return (
		<Dialog
			title='Kreiranje novog elementa'
			onClose={goBackFromCreate}
			open
		>
			<CategoryForm
				onSubmit={handleSave}
				onCancel={goBackFromCreate}
				crudEnum={CrudEnum.Create}
				articleType={additionalData.articleType}
			/>
			{loading && <LoadingSpinner />}
		</Dialog>
	)
}
